<template>
  <div class="operation-log">
    <a-form layout="inline" :form="form">
      <a-form-item>
        <a-input 
          placeholder="请输入您要搜索的内容"
          v-decorator="['keyword',{ rules: [{ required: true, message: '搜索内容不能为空!' }] },]"
        />
      </a-form-item>
      <a-form-item><a-button type="primary">搜索</a-button></a-form-item>
    </a-form>

    <a-table
      :columns="columns"
      :dataSource="data"
    >
    </a-table>
  </div>
</template>

<script>
const align = 'center'
const columns = [
  {
    title: "用户名",
    dataIndex: "name",
    align
  },
  {
    title: "IP",
    dataIndex: "age",
    align
  },
  {
    title: "IP来源",
    dataIndex: "address",
    align
  },
  {
    title: "描述",
    dataIndex: "",
    align
  },
  {
    title: "方法名称",
    dataIndex: "",
    align
  },
  {
    title: "参数",
    dataIndex: "",
    align
  },
  {
    title: "请求耗时",
    dataIndex: "",
    align
  },
  {
    title: "创建日期",
    dataIndex: "",
    align
  },
];
const data = [];
for (let i = 0; i < 46; i++) {
  data.push({
    key: i,
    name: `Edward King ${i}`,
    age: 32,
    address: `London, Park Lane no. ${i}`
  });
}
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      data,
      columns,
    };
  },
};
</script>

<style lang="less" scoped>
.operation-log {
  padding: 15px;
  .ant-form {
    padding: 0px 0px 30px;
  }
}
</style>
